import { render } from "./detail.vue?vue&type=template&id=12f8b3fe&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=12f8b3fe&lang=less&scoped=scoped"
import "./detail.vue?vue&type=style&index=1&id=12f8b3fe&lang=less"

import exportComponent from "F:\\project\\zifeiluntang\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f8b3fe"]])

export default __exports__